module.exports = __webpack_public_path__ + "img/紫草.7a48bd85.jpg";